var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-layout',{attrs:{"title":"Recuperar tu clave","subtitle":"Te enviamos un codigo para volver a entrar"}},[_c('form-password-reset')],1)}
var staticRenderFns = []

export { render, staticRenderFns }